var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_3438)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_910_3438",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: -5,
    width: 138,
    height: 167
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.816 -4.24748C129.829 2.03175 138.507 10.2217 145.355 19.8548C152.202 29.4878 157.086 40.3753 159.726 51.8956C162.366 63.416 162.711 75.3435 160.742 86.9972C158.772 98.6509 154.527 109.803 148.247 119.816C141.968 129.829 133.778 138.507 124.145 145.354C114.512 152.202 103.625 157.086 92.1043 159.726C80.584 162.366 68.6564 162.711 57.0027 160.742C45.349 158.772 34.1973 154.527 24.1843 148.247L72 71.9999L119.816 -4.24748Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_910_3438)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.3522 101.873L76.3522 132.127C76.3522 135.18 72.661 136.709 70.5022 134.55L56.7706 120.819C54.6617 118.71 54.6617 115.291 56.7706 113.182L70.5022 99.4502C72.661 97.2914 76.3522 98.8204 76.3522 101.873Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8053 42.1271L65.8053 11.8734C65.8053 8.82036 69.4965 7.29141 71.6553 9.45021L85.387 23.1818C87.4958 25.2907 87.4958 28.7098 85.387 30.8186L71.6553 44.5502C69.4965 46.709 65.8053 45.1801 65.8053 42.1271Z",
    fill: "#007BFF",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5457 118.259C80.8139 117.771 85.0305 116.69 89.0703 115.017C100.48 110.291 109.544 101.226 114.27 89.8169C118.996 78.4075 118.996 65.5881 114.27 54.1787C111.664 47.8875 107.739 42.3091 102.829 37.778M76.5147 118.263C76.4606 118.269 76.4065 118.275 76.3523 118.281M65.6118 25.741C61.3436 26.2293 57.127 27.3102 53.0872 28.9835C41.6778 33.7094 32.6131 42.7741 27.8872 54.1835C23.1613 65.5929 23.1613 78.4123 27.8872 89.8217C30.4931 96.113 34.4183 101.691 39.3283 106.222M65.6428 25.7374C65.6969 25.7313 65.7511 25.7252 65.8052 25.7192M76.3522 132.127L76.3522 101.873C76.3522 98.8204 72.661 97.2914 70.5022 99.4502L56.7706 113.182C54.6617 115.291 54.6617 118.71 56.7706 120.819L70.5022 134.55C72.661 136.709 76.3522 135.18 76.3522 132.127ZM65.8053 11.8734L65.8053 42.1271C65.8053 45.1801 69.4965 46.709 71.6553 44.5502L85.3869 30.8186C87.4958 28.7098 87.4958 25.2907 85.3869 23.1818L71.6553 9.45021C69.4965 7.29141 65.8053 8.82036 65.8053 11.8734Z",
    stroke: "#007BFF",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M121.651 71.9976L106.89 36.3594L71.2514 21.5976L35.6132 36.3594L20.8514 71.9976L35.6132 107.636L51.3271 114.145M71.2514 122.398L53.4323 115.017M121.307 72.0024L106.545 107.641L70.9068 122.402M70.9068 21.6024L88.7259 28.9833M53.0696 128.606C65.9363 132.7 79.8139 132.288 92.4153 127.439C105.017 122.589 115.59 113.591 122.392 101.927C129.194 90.2637 131.82 76.6305 129.836 63.2747C127.852 49.9189 121.377 37.6375 111.479 28.4547L71.0809 72.0022L53.0696 128.606ZM76.3525 140.4L76.3525 93.6003L52.9525 117L76.3525 140.4ZM46.4601 140.4L46.4601 93.6003L76.5458 93.6003L76.5458 140.4L46.4601 140.4ZM76.5149 140.338L76.5149 93.6003L53.1459 116.969L76.5149 140.338ZM89.0886 15.3943C76.2219 11.3002 62.3443 11.7118 49.7429 16.5613C37.1416 21.4109 26.5684 30.409 19.7661 42.0727C12.9637 53.7364 10.3381 67.3695 12.322 80.7253C14.3059 94.0811 20.7808 106.363 30.6797 115.545L71.0773 71.9978L89.0886 15.3943ZM65.8057 3.59979L65.8057 50.3998L89.2057 26.9998L65.8057 3.59979ZM95.6982 3.5998L95.6981 50.3998L65.6124 50.3998L65.6124 3.59979L95.6982 3.5998ZM65.6433 3.66176L65.6433 50.3997L89.0123 27.0308L65.6433 3.66176Z",
    stroke: "#007BFF",
    strokeWidth: 1.69,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.25 5.63"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_3438"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.d420c752f36c5e17ee4f359f19ee68f9.svg";
export { ForwardRef as ReactComponent };